// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-header.info-header i[data-v-63b5bff8] {
  color: var(--toolbtn-color);
}
.section-header.info-header i[data-v-63b5bff8]:hover {
  color: var(--toolbtn-color-hover);
}
.section-header.info-header .threads-header[data-v-63b5bff8] {
  display: flex;
  flex-direction: column;
  width: 11em;
  cursor: pointer;
}
.section-header.info-header .threads-header .subtitle[data-v-63b5bff8] {
  color: var(--message-grey-color);
  font-size: 14px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.section-header.info-header .header-back[data-v-63b5bff8] {
  font-size: 19px;
  margin-bottom: 4px;
}
.section-header.info-header .header-btns[data-v-63b5bff8] {
  margin-bottom: 3px;
}
.section-header.info-header .header-btns.thread-buttons-block[data-v-63b5bff8] {
  margin-right: 0;
}
.section-header.info-header .header-btns.thread-buttons-block .btn-custom[data-v-63b5bff8] {
  display: flex;
  align-items: center;
  justify-content: center;
}
.section-header.info-header .header-btns.thread-buttons-block .btn-custom i.fa-window-maximize[data-v-63b5bff8] {
  font-size: inherit;
  margin-left: unset;
}
.section-header.info-header .header-btns.thread-buttons-block .btn-custom i.fa-phone[data-v-63b5bff8] {
  font-size: 0.96em;
  margin-left: unset;
}
.section-header.info-header .header-btns.thread-buttons-block .btn-custom[data-v-63b5bff8]:hover {
  color: var(--toolbtn-color-hover) !important;
}
.section-header.info-header .header-btns.thread-buttons-block .btn-custom.menu[data-v-63b5bff8] {
  width: 1.14em;
}
.section-header.info-header .header-btns.thread-buttons-block .header-thread-search[data-v-63b5bff8] {
  margin-bottom: -2px;
}
.section-header.info-header .header-btns.thread-buttons-block .header-thread-search[data-v-63b5bff8]:hover:before {
  color: var(--toolbtn-color-hover);
}
.section-header.info-header .header-btns.thread-buttons-block .header-thread-search[data-v-63b5bff8]:before {
  content: "\\F002";
  font-family: "Font Awesome 5 Pro";
  color: var(--toolbtn-color);
}
.section-header.info-header .info-header-btns-search[data-v-63b5bff8] {
  margin-left: unset;
}
.section-header.info-header .info-header-search[data-v-63b5bff8] {
  margin-right: 10px;
  margin-left: auto;
}
.section-header.info-header .header-chat-search[data-v-63b5bff8] {
  color: var(--toolbtn-color);
}
.section-header.info-header .header-chat-search[data-v-63b5bff8]:before {
  content: "\\F002";
  font-family: "Font Awesome 5 Pro";
  margin-top: 4px;
}
.section-header.info-header .header-chat-search[data-v-63b5bff8]:hover {
  color: var(--toolbtn-color-hover) !important;
}
.section-header.info-header .info-header-search-members[data-v-63b5bff8] {
  color: var(--toolbtn-color);
}
.section-header.info-header .info-header-search-members[data-v-63b5bff8]:before {
  content: "\\F002";
  font-family: "Font Awesome 5 Pro";
  margin-top: 4px;
  font-size: 1.4em;
}
.section-header.info-header .info-header-search-members[data-v-63b5bff8]:hover {
  color: var(--toolbtn-color-hover) !important;
}
.show[data-v-63b5bff8] {
  transition-property: width;
  transition-duration: 0.25s;
  opacity: 100%;
}
.hide[data-v-63b5bff8] {
  opacity: 0;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/info/InfoHeader.vue"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;AACA;EACE,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,2BAA2B;AAC7B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;AACjB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,aAAa;AACf;AACA;EACE,UAAU;AACZ","sourcesContent":[".section-header.info-header i[data-v-63b5bff8] {\n  color: var(--toolbtn-color);\n}\n.section-header.info-header i[data-v-63b5bff8]:hover {\n  color: var(--toolbtn-color-hover);\n}\n.section-header.info-header .threads-header[data-v-63b5bff8] {\n  display: flex;\n  flex-direction: column;\n  width: 11em;\n  cursor: pointer;\n}\n.section-header.info-header .threads-header .subtitle[data-v-63b5bff8] {\n  color: var(--message-grey-color);\n  font-size: 14px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.section-header.info-header .header-back[data-v-63b5bff8] {\n  font-size: 19px;\n  margin-bottom: 4px;\n}\n.section-header.info-header .header-btns[data-v-63b5bff8] {\n  margin-bottom: 3px;\n}\n.section-header.info-header .header-btns.thread-buttons-block[data-v-63b5bff8] {\n  margin-right: 0;\n}\n.section-header.info-header .header-btns.thread-buttons-block .btn-custom[data-v-63b5bff8] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.section-header.info-header .header-btns.thread-buttons-block .btn-custom i.fa-window-maximize[data-v-63b5bff8] {\n  font-size: inherit;\n  margin-left: unset;\n}\n.section-header.info-header .header-btns.thread-buttons-block .btn-custom i.fa-phone[data-v-63b5bff8] {\n  font-size: 0.96em;\n  margin-left: unset;\n}\n.section-header.info-header .header-btns.thread-buttons-block .btn-custom[data-v-63b5bff8]:hover {\n  color: var(--toolbtn-color-hover) !important;\n}\n.section-header.info-header .header-btns.thread-buttons-block .btn-custom.menu[data-v-63b5bff8] {\n  width: 1.14em;\n}\n.section-header.info-header .header-btns.thread-buttons-block .header-thread-search[data-v-63b5bff8] {\n  margin-bottom: -2px;\n}\n.section-header.info-header .header-btns.thread-buttons-block .header-thread-search[data-v-63b5bff8]:hover:before {\n  color: var(--toolbtn-color-hover);\n}\n.section-header.info-header .header-btns.thread-buttons-block .header-thread-search[data-v-63b5bff8]:before {\n  content: \"\\F002\";\n  font-family: \"Font Awesome 5 Pro\";\n  color: var(--toolbtn-color);\n}\n.section-header.info-header .info-header-btns-search[data-v-63b5bff8] {\n  margin-left: unset;\n}\n.section-header.info-header .info-header-search[data-v-63b5bff8] {\n  margin-right: 10px;\n  margin-left: auto;\n}\n.section-header.info-header .header-chat-search[data-v-63b5bff8] {\n  color: var(--toolbtn-color);\n}\n.section-header.info-header .header-chat-search[data-v-63b5bff8]:before {\n  content: \"\\F002\";\n  font-family: \"Font Awesome 5 Pro\";\n  margin-top: 4px;\n}\n.section-header.info-header .header-chat-search[data-v-63b5bff8]:hover {\n  color: var(--toolbtn-color-hover) !important;\n}\n.section-header.info-header .info-header-search-members[data-v-63b5bff8] {\n  color: var(--toolbtn-color);\n}\n.section-header.info-header .info-header-search-members[data-v-63b5bff8]:before {\n  content: \"\\F002\";\n  font-family: \"Font Awesome 5 Pro\";\n  margin-top: 4px;\n  font-size: 1.4em;\n}\n.section-header.info-header .info-header-search-members[data-v-63b5bff8]:hover {\n  color: var(--toolbtn-color-hover) !important;\n}\n.show[data-v-63b5bff8] {\n  transition-property: width;\n  transition-duration: 0.25s;\n  opacity: 100%;\n}\n.hide[data-v-63b5bff8] {\n  opacity: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
